import React from 'react';
import { Badge, Container } from 'react-bootstrap';

export const Header: React.FC<React.PropsWithChildren<unknown>> = () => {
  const headerColor = process.env.REACT_APP_HEADER_COLOR;

  return (
    <Container className="header" style={{ backgroundColor: headerColor }}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <h3>Final Terms</h3>
          {process.env.REACT_APP_BADGE_ENV_TEXT && (
            <h3>
              <Badge className="ms-2" pill bg={process.env.REACT_APP_BADGE_ENV_COLOR}>
                {process.env.REACT_APP_BADGE_ENV_TEXT}
              </Badge>
            </h3>
          )}
        </div>
        <img src={`${process.env.PUBLIC_URL}/img/logo-cssf-white.png`} title="CSSF logo" alt="CSSF" />
      </div>
    </Container>
  );
};
